import { createBrowserRouter, type RouteObject } from "react-router";
import routes from "@/router/routes";
import type { RouteConfig } from "@/router/types";
import { Sentry } from "@/shared/clients/sentry.client";
import { RouteErrorBoundary } from "@/shared/components/RouteErrorBoundary";
import AppLayout from "@/shared/layouts/AppLayout";

const createRouteElement = (route: RouteConfig) => <AppLayout route={route} />;

const mapRoute = (route: RouteConfig): RouteObject => {
  const {
    children, isProtected, useMainLayout, mainBackground, index, ...rest
  } = route;

  const baseProps = {
    ...rest,
    element: createRouteElement(route),
    errorElement: <RouteErrorBoundary />,
  };

  if (index) {
    return { ...baseProps, index: true };
  }

  return {
    ...baseProps,
    children: children?.map((child) => mapRoute(child)),
  };
};

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const appRouter = sentryCreateBrowserRouter(routes.map(mapRoute));

export default appRouter;
